/* BOMBERG NEO MICTLAN - cut-paper clouds, smoke, spotlight, chapters, video */
(function () {
  if (window.__mictlan) return;
  window.__mictlan = true;

  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DESIGN = window.Shopify && window.Shopify.designMode;
  var MOBILE = window.matchMedia('(max-width: 749px), (hover: none)').matches;

  function rng(seed) {
    var a = seed >>> 0;
    return function () {
      a = (a + 0x6d2b79f5) | 0;
      var t = Math.imul(a ^ (a >>> 15), 1 | a);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }
  function shade(hex, amt) {
    var h = hex.replace('#', '');
    if (h.length === 3) h = h.replace(/./g, '$&$&');
    var n = parseInt(h, 16);
    var r = Math.max(0, Math.min(255, (n >> 16) + amt));
    var g = Math.max(0, Math.min(255, ((n >> 8) & 255) + amt));
    var b = Math.max(0, Math.min(255, (n & 255) + amt));
    return 'rgb(' + r + ',' + g + ',' + b + ')';
  }
  function progress(el) {
    var r = el.getBoundingClientRect();
    var vh = window.innerHeight;
    return Math.max(0, Math.min(1, (vh - r.top) / (vh + r.height)));
  }

  var seen = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      e.target.__vis = e.isIntersecting;
      if (e.isIntersecting && e.target.kick) e.target.kick();
    });
  }, { rootMargin: '120px' });

  /* Base for animated canvas elements */
  function CanvasEl() { return Reflect.construct(HTMLElement, [], new.target); }
  CanvasEl.prototype = Object.create(HTMLElement.prototype);
  CanvasEl.prototype.connectedCallback = function () {
    var self = this;
    if (this.__ready) return;
    this.__ready = true;
    this.c = document.createElement('canvas');
    this.appendChild(this.c);
    this.ctx = this.c.getContext('2d');
    this.raf = 0;
    this.loop = function (t) {
      self.raf = 0;
      t = t || performance.now();
      if (!self.lastDraw || t - self.lastDraw > 32 || self.scrolled) { self.draw(t); self.drawn = true; self.lastDraw = t; self.scrolled = false; }
      if (!RM && self.__vis && self.animated) self.raf = requestAnimationFrame(self.loop);
    };
    this.kick = function () { if (self.still && self.drawn) return; self.scrolled = true; if (!self.raf && self.__vis !== false) self.raf = requestAnimationFrame(self.loop); };
    this.ro = new ResizeObserver(function () { self.drawn = false; self.resize(); self.kick(); });
    this.ro.observe(this);
    seen.observe(this);
    window.addEventListener('scroll', this.kick, { passive: true });
  };
  CanvasEl.prototype.disconnectedCallback = function () {
    this.__ready = false;
    if (this.ro) this.ro.disconnect();
    seen.unobserve(this);
    window.removeEventListener('scroll', this.kick);
    cancelAnimationFrame(this.raf);
    if (this.c) this.c.remove();
  };
  CanvasEl.prototype.resize = function () {
    var d = this.res ? this.res() : Math.min(window.devicePixelRatio || 1, 2);
    this.w = this.clientWidth;
    this.h = this.clientHeight;
    this.d = d;
    this.c.width = Math.max(1, Math.round(this.w * d));
    this.c.height = Math.max(1, Math.round(this.h * d));
    this.build && this.build();
  };
  Object.setPrototypeOf(CanvasEl, HTMLElement);

  /* <mtl-clouds>: layered cut-paper cloud scrolls, like the stage sets in the film */
  function Clouds() { return Reflect.construct(CanvasEl, [], new.target); }
  Clouds.prototype = Object.create(CanvasEl.prototype);
  Object.setPrototypeOf(Clouds, CanvasEl);
  Clouds.prototype.build = function () {
    var w = this.w, h = this.h;
    if (!w || !h) return;
    var n = Math.max(1, Math.min(7, +this.dataset.layers || 4));
    var r = rng(+this.dataset.seed || 9);
    var cols = (this.dataset.colors || '#4a4947,#7a7976,#a9a8a4,#d6d5d1').split(',').map(function (s) { return s.trim(); });
    var scale = +this.dataset.scale || 1;
    this.animated = this.dataset.motion !== 'off' && !MOBILE;
    this.still = MOBILE;
    /* clear band at the open edge: shadows never get cut by the canvas edge */
    var m = this.margin = Math.min(110, Math.max(36, h * 0.3));
    var blend = this.dataset.blend === 'off' ? '' : (getComputedStyle(this).getPropertyValue('--mtl-bg').trim() || '#0a0a0b');
    var total = n + (blend ? 1 : 0);
    this.layers = [];
    for (var i = 0; i < total; i++) {
      var isBlend = blend && i === n;
      var t = total > 1 ? i / (total - 1) : 1;
      var base = m + (h - m) * (isBlend ? 0.9 : 0.12 + 0.62 * (n > 1 ? i / (n - 1) : 1) * (blend ? 0.85 : 1));
      var bumps = [];
      var x = -w * 0.15;
      while (x < w * 1.15) {
        var rad = Math.max(24, w * (0.045 + r() * 0.07) * (0.75 + 0.55 * t) * scale);
        rad = Math.min(rad, Math.max(18, base - m * 0.62));
        bumps.push({ x: x + rad, r: rad, curl: !isBlend && r() < 0.6, dir: r() < 0.5 ? 1 : -1, tick: isBlend ? 0 : r() });
        x += rad * (1.35 + r() * 0.45);
      }
      this.layers.push({ base: base, bumps: bumps, color: isBlend ? blend : cols[Math.min(cols.length - 1, Math.round((n > 1 ? i / (n - 1) : 1) * (cols.length - 1)))], t: t, ph: r() * 6.28 });
    }
  };
  /* Paint one paper layer once into its own bitmap; animation only moves bitmaps. */
  Clouds.prototype.res = function () { return Math.min(window.devicePixelRatio || 1, MOBILE ? 1.5 : 2); };
  Clouds.prototype.paint = function (L) {
    var d = this.d, w = this.w, h = this.h, mx = Math.round(w * 0.08), pad = 140;
    var off = document.createElement('canvas');
    off.width = Math.ceil((w + mx * 2) * d);
    off.height = Math.ceil((h + pad) * d);
    var ctx = off.getContext('2d');
    ctx.setTransform(d, 0, 0, d, mx * d, 0);
    ctx.beginPath();
    var b0 = L.bumps[0];
    ctx.moveTo(b0.x - b0.r, h + pad);
    for (var j = 0; j < L.bumps.length; j++) {
      var b = L.bumps[j];
      ctx.lineTo(b.x - b.r, L.base);
      ctx.arc(b.x, L.base, b.r, Math.PI, 0, false);
    }
    var bl = L.bumps[L.bumps.length - 1];
    ctx.lineTo(bl.x + bl.r, h + pad);
    ctx.closePath();
    ctx.shadowColor = 'rgba(0,0,0,0.55)';
    ctx.shadowBlur = 26 * d;
    ctx.shadowOffsetY = -6 * d;
    ctx.fillStyle = L.color;
    ctx.fill();
    ctx.shadowColor = 'transparent';
    ctx.lineCap = 'round';
    ctx.strokeStyle = shade(L.color, 34);
    ctx.lineWidth = Math.max(1.5, 2.4 * (0.6 + L.t * 0.6));
    for (var k = 0; k < L.bumps.length; k++) {
      var c = L.bumps[k];
      if (c.curl) {
        ctx.beginPath();
        var cx = c.x + c.dir * c.r * 0.12, cy = L.base - c.r * 0.12;
        for (var s = 0; s <= 46; s++) {
          var an = (s / 46) * 1.55 * Math.PI * 2 * c.dir + Math.PI;
          var rr = c.r * 0.66 * (1 - (s / 46) * 0.82);
          var px = cx + Math.cos(an) * rr, py = cy + Math.sin(an) * rr;
          s ? ctx.lineTo(px, py) : ctx.moveTo(px, py);
        }
        ctx.stroke();
      }
      if (c.tick > 0.45) {
        ctx.beginPath();
        ctx.arc(c.x + c.r * (c.tick - 0.7), L.base + c.r * (0.35 + c.tick * 0.4), c.r * 0.28, Math.PI * 1.15, Math.PI * 1.75);
        ctx.stroke();
      }
    }
    L.bmp = off; L.mx = mx;
  };
  Clouds.prototype.draw = function (now) {
    var ctx = this.ctx, d = this.d, w = this.w, h = this.h;
    if (!this.layers || !w) return;
    var flip = this.hasAttribute('data-flip');
    var p = MOBILE ? 0 : progress(this) - 0.5;
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.clearRect(0, 0, this.c.width, this.c.height);
    ctx.setTransform(1, 0, 0, flip ? -1 : 1, 0, flip ? this.c.height : 0);
    for (var i = 0; i < this.layers.length; i++) {
      var L = this.layers[i];
      if (!L.bmp) this.paint(L);
      var drift = RM || MOBILE ? 0 : Math.sin(now * 0.00018 * (1 + L.t) + L.ph) * w * 0.01 * (1 + i);
      var par = RM ? 0 : -p * this.margin * 0.5 * (0.3 + L.t);
      ctx.drawImage(L.bmp, Math.round((drift - L.mx) * d), Math.round(par * d));
    }
    /* fade the open edge so nothing ever shows a hard line */
    ctx.save();
    ctx.globalCompositeOperation = 'destination-in';
    var fade = ctx.createLinearGradient(0, 0, 0, this.margin * 0.7 * d);
    fade.addColorStop(0, 'rgba(0,0,0,0)');
    fade.addColorStop(1, 'rgba(0,0,0,1)');
    ctx.fillStyle = fade;
    ctx.fillRect(0, 0, this.c.width, this.c.height);
    ctx.restore();
  };

  /* <mtl-smoke>: slow drifting smoke, as in the closing frames */
  function Smoke() { return Reflect.construct(CanvasEl, [], new.target); }
  Smoke.prototype = Object.create(CanvasEl.prototype);
  Object.setPrototypeOf(Smoke, CanvasEl);
  Smoke.prototype.res = function () { return MOBILE ? 0.4 : 0.6; };
  Smoke.prototype.build = function () {
    this.animated = true;
    var r = rng(+this.dataset.seed || 3);
    if (!this.sprite) {
      var s = document.createElement('canvas');
      s.width = s.height = 256;
      var g = s.getContext('2d');
      for (var i = 0; i < 14; i++) {
        var x = 128 + (r() - 0.5) * 110, y = 128 + (r() - 0.5) * 110, rad = 40 + r() * 70;
        var gr = g.createRadialGradient(x, y, 0, x, y, rad);
        gr.addColorStop(0, 'rgba(255,255,255,0.22)');
        gr.addColorStop(1, 'rgba(255,255,255,0)');
        g.fillStyle = gr;
        g.fillRect(0, 0, 256, 256);
      }
      this.sprite = s;
    }
    var dens = Math.max(0, Math.min(100, +this.dataset.density || 50));
    var n = Math.round((4 + dens * 0.2 * Math.min(1.4, this.w / 900)) * (MOBILE ? 0.5 : 1));
    var from = this.dataset.origin || 'bottom';
    this.parts = [];
    for (var k = 0; k < n; k++) {
      this.parts.push({
        x: r() * this.w,
        y: from === 'full' ? r() * this.h : this.h * (0.55 + r() * 0.55),
        s: (160 + r() * 360) * Math.max(0.6, this.w / 1400),
        vx: (r() - 0.5) * 0.08,
        vy: -(0.02 + r() * 0.06),
        a: 0.12 + r() * 0.3,
        rot: r() * 6.28,
        vr: (r() - 0.5) * 0.0004,
        ph: r() * 6.28
      });
    }
  };
  Smoke.prototype.draw = function (now) {
    var ctx = this.ctx, d = this.d;
    if (!this.parts) return;
    var dt = this.last ? Math.min(64, now - this.last) : 16;
    this.last = now;
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.clearRect(0, 0, this.c.width, this.c.height);
    ctx.setTransform(d, 0, 0, d, 0, 0);
    var tint = this.dataset.tint || '';
    for (var i = 0; i < this.parts.length; i++) {
      var q = this.parts[i];
      if (!RM) {
        q.x += q.vx * dt;
        q.y += q.vy * dt;
        q.rot += q.vr * dt;
        if (q.y < -q.s * 0.6) { q.y = this.h + q.s * 0.4; q.x = Math.random() * this.w; }
        if (q.x < -q.s) q.x = this.w + q.s * 0.5;
        if (q.x > this.w + q.s) q.x = -q.s * 0.5;
      }
      var fade = Math.min(1, Math.max(0, (this.h - q.y) / (this.h * 0.25))) * Math.min(1, Math.max(0, (q.y + q.s * 0.5) / (this.h * 0.45)));
      ctx.globalAlpha = q.a * fade * (0.75 + 0.25 * Math.sin(now * 0.0004 + q.ph));
      ctx.save();
      ctx.translate(q.x, q.y);
      ctx.rotate(q.rot);
      ctx.drawImage(this.sprite, -q.s / 2, -q.s / 2, q.s, q.s);
      ctx.restore();
    }
    ctx.globalAlpha = 1;
    if (tint) {
      ctx.globalCompositeOperation = 'source-atop';
      ctx.fillStyle = tint;
      ctx.globalAlpha = 0.18;
      ctx.fillRect(0, 0, this.w, this.h);
      ctx.globalAlpha = 1;
      ctx.globalCompositeOperation = 'source-over';
    }
  };

  /* <mtl-spotlight>: torch over the caseback engraving */
  function Spot() { return Reflect.construct(HTMLElement, [], new.target); }
  Spot.prototype = Object.create(HTMLElement.prototype);
  Object.setPrototypeOf(Spot, HTMLElement);
  Spot.prototype.connectedCallback = function () {
    var self = this;
    if (this.__ready) return;
    this.__ready = true;
    this.user = false;
    var set = function (x, y) { self.style.setProperty('--x', x + '%'); self.style.setProperty('--y', y + '%'); };
    var move = function (e) {
      var r = self.getBoundingClientRect();
      self.user = true;
      clearTimeout(self.idle);
      self.idle = setTimeout(function () { self.user = false; tick(); }, 2400);
      set(((e.clientX - r.left) / r.width) * 100, ((e.clientY - r.top) / r.height) * 100);
    };
    this.addEventListener('pointermove', move);
    this.addEventListener('pointerdown', move);
    var tick = function (t) {
      if (self.user || !self.isConnected) return;
      t = t || performance.now();
      if (!self.lt || t - self.lt > 32) { self.lt = t; set(50 + Math.cos(t * 0.00045) * 26, 50 + Math.sin(t * 0.00058) * 22); }
      if (!RM && self.__vis) requestAnimationFrame(tick);
    };
    this.kick = function () { if (!self.user && !MOBILE) requestAnimationFrame(tick); };
    seen.observe(this);
    if (RM) set(50, 42);
  };
  Spot.prototype.disconnectedCallback = function () { seen.unobserve(this); this.__ready = false; };

  /* <mtl-chapters>: sticky stage that follows the scrolling text */
  function Chapters() { return Reflect.construct(HTMLElement, [], new.target); }
  Chapters.prototype = Object.create(HTMLElement.prototype);
  Object.setPrototypeOf(Chapters, HTMLElement);
  Chapters.prototype.connectedCallback = function () {
    var self = this;
    if (this.__ready) return;
    this.__ready = true;
    this.steps = Array.prototype.slice.call(this.querySelectorAll('[data-step]'));
    this.frames = Array.prototype.slice.call(this.querySelectorAll('[data-frame]'));
    this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-dot]'));
    this.io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) self.go(+e.target.dataset.step); });
    }, { rootMargin: '-45% 0px -45% 0px' });
    this.steps.forEach(function (s) { self.io.observe(s); });
    this.go(0);
  };
  Chapters.prototype.disconnectedCallback = function () { if (this.io) this.io.disconnect(); this.__ready = false; };
  Chapters.prototype.go = function (i) {
    var on = function (list) { list.forEach(function (el, k) { el.classList.toggle('is-active', k === i); }); };
    on(this.steps); on(this.frames); on(this.dots);
    var f = this.frames[i], ink = f && f.querySelector('.mtl-ink');
    if (ink) ink.classList.add('is-lit');
  };

  /* <mtl-video>: autoplay muted when visible, sound toggle */
  function Vid() { return Reflect.construct(HTMLElement, [], new.target); }
  Vid.prototype = Object.create(HTMLElement.prototype);
  Object.setPrototypeOf(Vid, HTMLElement);
  Vid.prototype.connectedCallback = function () {
    var self = this;
    if (this.__ready) return;
    this.__ready = true;
    this.v = this.querySelector('video');
    this.b = this.querySelector('[data-sound]');
    if (!this.v) return;
    this.io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting && !RM) { var pr = self.v.play(); if (pr && pr.catch) pr.catch(function () {}); }
        else self.v.pause();
      });
    }, { threshold: 0.35 });
    this.io.observe(this);
    if (this.b) this.b.addEventListener('click', function () {
      self.v.muted = !self.v.muted;
      self.b.setAttribute('aria-pressed', String(!self.v.muted));
      if (self.v.paused) self.v.play();
    });
  };
  Vid.prototype.disconnectedCallback = function () { if (this.io) this.io.disconnect(); this.__ready = false; };

  var defs = { 'mtl-clouds': Clouds, 'mtl-smoke': Smoke, 'mtl-spotlight': Spot, 'mtl-chapters': Chapters, 'mtl-video': Vid };
  Object.keys(defs).forEach(function (k) { if (!customElements.get(k)) customElements.define(k, defs[k]); });


  /* ---------- Pair state: which watch is selected ---------- */
  var root = document.documentElement;
  function setPick(p, silent) {
    if (p !== 'a' && p !== 'b') return;
    root.setAttribute('data-mtl-pick', p);
    document.querySelectorAll('[data-mtl-pick-btn]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-mtl-pick-btn') === p));
    });
    if (!silent) document.dispatchEvent(new CustomEvent('mictlan:pick', { detail: { pick: p } }));
  }
  window.mictlanPick = setPick;
  setPick(root.getAttribute('data-mtl-pick') || 'a', true);
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-mtl-pick-btn]');
    if (!b) return;
    var dp = b.closest('.mtl-duo__p');
    if (dp && window.matchMedia('(hover: none)').matches && !dp.classList.contains('is-open')) return;
    e.preventDefault();
    setPick(b.getAttribute('data-mtl-pick-btn'));
    if (b.hasAttribute('data-mtl-goto-buy')) {
      var t = document.querySelector('[data-mtl-buy]');
      if (t) t.scrollIntoView({ behavior: RM ? 'auto' : 'smooth', block: 'start' });
    }
  });
  document.addEventListener('shopify:section:load', function () { setPick(root.getAttribute('data-mtl-pick') || 'a', true); });


  /* <mtl-engrave>: caseback engraving that lights up along its lines, like vines.
     Drawn on a canvas: each band of lines is prepared once, a frame only paints the bands that are lighting up. */
  var engSprite = null, engArt = {};
  function loadSprite(src) {
    if (!engSprite) engSprite = fetch(src).then(function (r) { return r.text(); }).then(function (t) {
      return new DOMParser().parseFromString(t, 'image/svg+xml');
    });
    return engSprite;
  }
  function artFor(doc, name) {
    if (engArt[name]) return engArt[name];
    var svg = doc.getElementById('mtl-art-' + name);
    if (!svg) return null;
    var g = svg.querySelector('g[transform]');
    var m = /translate\(([-\d.]+)[ ,]+([-\d.]+)\)\s*scale\(([-\d.]+)[ ,]+([-\d.]+)\)/.exec(g.getAttribute('transform')) || [0, 0, 0, 1, 1];
    var bands = Array.prototype.map.call(svg.querySelectorAll('.bnd'), function (b) {
      var path = new Path2D();
      b.querySelectorAll('path').forEach(function (pp) { path.addPath(new Path2D(pp.getAttribute('d'))); });
      return path;
    });
    engArt[name] = { tx: +m[1], ty: +m[2], sx: +m[3], sy: +m[4], bands: bands, size: 1320 };
    return engArt[name];
  }
  function mixWhite(col, pct) {
    var c = document.createElement('canvas').getContext('2d');
    c.fillStyle = col; var h = c.fillStyle;
    if (h.charAt(0) !== '#') return col;
    var n = parseInt(h.slice(1), 16), k = pct / 100;
    var r = (n >> 16) & 255, g = (n >> 8) & 255, b = n & 255;
    return 'rgb(' + Math.round(r * k + 255 * (1 - k)) + ',' + Math.round(g * k + 255 * (1 - k)) + ',' + Math.round(b * k + 255 * (1 - k)) + ')';
  }
  function Engrave() { return Reflect.construct(HTMLElement, [], new.target); }
  Engrave.prototype = Object.create(HTMLElement.prototype);
  Object.setPrototypeOf(Engrave, HTMLElement);
  Engrave.prototype.connectedCallback = function () {
    var self = this;
    if (this.__ready) return;
    this.__ready = true;
    this.lit = false;
    var src = this.getAttribute('data-src');
    if (!src) return;
    this.near = new IntersectionObserver(function (es) {
      if (!es.some(function (e) { return e.isIntersecting; })) return;
      self.near.disconnect();
      loadSprite(src).then(function (doc) {
        self.art = artFor(doc, self.getAttribute('data-art') || 'viajero');
        if (!self.art) return;
        self.c = document.createElement('canvas');
        self.c.setAttribute('aria-hidden', 'true');
        self.appendChild(self.c);
        self.ro = new ResizeObserver(function () { self.layout(); });
        self.ro.observe(self);
        self.layout();
        self.sync();
      });
    }, { rootMargin: '600px 0px' });
    this.near.observe(this);
    this.io = new IntersectionObserver(function (es) { es.forEach(function (e) { self.__vis = e.isIntersecting; self.sync(); }); }, { threshold: 0.3 });
    this.io.observe(this);
    this.onPick = function () { self.colors(); self.sync(true); };
    this.onDuo = function () { self.sync(false); };
    document.addEventListener('mictlan:pick', this.onPick);
    document.addEventListener('mictlan:duo', this.onDuo);
  };
  Engrave.prototype.disconnectedCallback = function () {
    this.__ready = false;
    [this.io, this.near, this.ro].forEach(function (o) { if (o) o.disconnect(); });
    document.removeEventListener('mictlan:pick', this.onPick);
    document.removeEventListener('mictlan:duo', this.onDuo);
    cancelAnimationFrame(this.raf);
  };
  Engrave.prototype.colors = function () {
    var cs = getComputedStyle(this);
    this.dim = (cs.getPropertyValue('--eng-dim') || '#232326').trim() || '#232326';
    this.col = mixWhite((cs.getPropertyValue('--g') || '#ff9f1c').trim() || '#ff9f1c', 78);
    this.step = (parseFloat(cs.getPropertyValue('--eng-step')) || 0.24) * 1000;
    this.delay = (parseFloat(cs.getPropertyValue('--eng-delay')) || 0) * 1000;
    if (this.base) this.paintBase();
    if (this.litC) { this.litC.getContext('2d').clearRect(0, 0, this.litC.width, this.litC.height); this.done = 0; }
    this.frame();
  };
  Engrave.prototype.layout = function () {
    var w = this.clientWidth;
    if (!w || !this.c) return;
    var d = Math.min(window.devicePixelRatio || 1, MOBILE ? 1.25 : 1.5), px = Math.round(w * d);
    if (px === this.px) return;
    this.px = px;
    this.c.width = this.c.height = px;
    this.base = document.createElement('canvas'); this.base.width = this.base.height = px;
    this.litC = document.createElement('canvas'); this.litC.width = this.litC.height = px;
    this.done = 0;
    this.colors();
  };
  Engrave.prototype.prep = function (ctx) {
    var a = this.art, k = this.px / a.size;
    ctx.setTransform(k * a.sx, 0, 0, k * a.sy, k * a.tx, k * a.ty);
  };
  Engrave.prototype.paintBase = function () {
    var ctx = this.base.getContext('2d');
    ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.clearRect(0, 0, this.px, this.px);
    this.prep(ctx); ctx.fillStyle = this.dim;
    var whole = new Path2D(); this.art.bands.forEach(function (b) { whole.addPath(b); });
    ctx.fill(whole);
  };
  Engrave.prototype.frame = function (now) {
    if (!this.c || !this.base) return;
    var ctx = this.c.getContext('2d'), n = this.art.bands.length, FADE = 1800;
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.clearRect(0, 0, this.px, this.px);
    ctx.drawImage(this.base, 0, 0);
    if (!this.lit) return;
    var t = (now || performance.now()) - this.t0, active = false;
    var lctx = this.litC.getContext('2d');
    while (this.done < n && t - this.delay - this.done * this.step >= FADE) {
      this.prep(lctx); lctx.fillStyle = this.col; lctx.fill(this.art.bands[this.done]); this.done++;
    }
    ctx.drawImage(this.litC, 0, 0);
    this.prep(ctx); ctx.fillStyle = this.col;
    for (var i = this.done; i < n; i++) {
      var p = (t - this.delay - i * this.step) / FADE;
      if (p <= 0) { active = true; break; }
      ctx.globalAlpha = p * p * (3 - 2 * p);
      ctx.fill(this.art.bands[i]);
      active = true;
    }
    ctx.globalAlpha = 1;
    return active;
  };
  Engrave.prototype.run = function () {
    var self = this;
    cancelAnimationFrame(this.raf);
    var last = 0;
    function tick(now) {
      if (!self.lit) return;
      if (now - last >= 32) { last = now; if (!self.frame(now)) return; }
      self.raf = requestAnimationFrame(tick);
    }
    this.raf = requestAnimationFrame(tick);
  };
  Engrave.prototype.light = function (replay) {
    if (this.lit && !replay) return;
    this.lit = true;
    if (this.litC) { this.litC.getContext('2d').setTransform(1, 0, 0, 1, 0, 0); this.litC.getContext('2d').clearRect(0, 0, this.px, this.px); }
    this.done = 0;
    this.t0 = performance.now() - (RM || DESIGN ? 1e9 : 0);
    this.run();
  };
  Engrave.prototype.sync = function (picked) {
    var key = this.getAttribute('data-key');
    var front = !key || key === (root.getAttribute('data-mtl-pick') || 'a') || (root.classList.contains('mtl-duo-view') && this.closest('.mtl-buy'));
    if (!front) { this.lit = false; cancelAnimationFrame(this.raf); this.frame(); return; }
    if ((this.__vis || DESIGN) && this.c) this.light(picked && !this.lit);
  };
  if (!customElements.get('mtl-engrave')) customElements.define('mtl-engrave', Engrave);

  /* ---------- Depth: layers move at their own speed (desktop only) ---------- */
  var depthEls = [], depthRaf = 0;
  function collectDepth() { depthEls = MOBILE ? [] : Array.prototype.slice.call(document.querySelectorAll('[data-mtl-depth]')); }
  function depthFrame() {
    depthRaf = 0;
    var vh = window.innerHeight;
    for (var i = 0; i < depthEls.length; i++) {
      var el = depthEls[i], host = el.__host || (el.__host = el.closest('.mtl') || el);
      var r = host.getBoundingClientRect();
      var near = !(r.bottom < -200 || r.top > vh + 200);
      if (near !== el.__near) { el.__near = near; el.classList.toggle('mtl-moving', near); }
      if (!near) continue;
      var c = (r.top + r.height / 2 - vh / 2) / vh;
      var v = Math.round(c * (+el.getAttribute('data-mtl-depth') || 0) * -240);
      if (el.__py !== v) { el.__py = v; el.style.setProperty('--py', v + 'px'); }
    }
  }
  function depthKick() { if (!depthRaf && !RM && depthEls.length) depthRaf = requestAnimationFrame(depthFrame); }
  collectDepth(); depthKick();
  window.addEventListener('scroll', depthKick, { passive: true });
  window.addEventListener('resize', depthKick);
  document.addEventListener('shopify:section:load', function () { collectDepth(); depthKick(); });

  /* ---------- Ink: black and white that fills with color on view ---------- */
  var inkIO = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-lit'); inkIO.unobserve(e.target); } });
  }, { threshold: 0.35 });
  function scanInk(rootEl) {
    (rootEl || document).querySelectorAll('.mtl-ink[data-mtl-ink="view"]:not(.is-lit)').forEach(function (el) {
      if (DESIGN || RM) el.classList.add('is-lit'); else inkIO.observe(el);
    });
  }
  scanInk();
  document.addEventListener('shopify:section:load', function (e) { scanInk(e.target); });

  /* ---------- Buy: add the selected watch or both ---------- */
  function moneyFmt(cents, fmt) {
    var v = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (fmt || '${{amount}}').replace(/\{\{\s*amount[a-z_]*\s*\}\}/, v);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-mtl-add]');
    if (!b) return;
    e.preventDefault();
    var box = b.closest('[data-mtl-cart]') || document.querySelector('[data-mtl-cart]');
    if (!box) return;
    if (root.classList.contains('mtl-locked')) return;
    var mode = b.getAttribute('data-mtl-add');
    var pick = root.getAttribute('data-mtl-pick') || 'a';
    var ids = mode === 'both' ? [box.dataset.va, box.dataset.vb] : [mode === 'pick' ? box.dataset['v' + pick] : box.dataset['v' + mode]];
    ids = ids.filter(Boolean);
    var msg = box.querySelector('.mtl-msg');
    if (!ids.length) { if (msg) msg.textContent = box.dataset.soon || ''; return; }
    b.classList.add('is-busy');
    var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(rootUrl + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: ids.map(function (id) { return { id: +id, quantity: 1 }; }) })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        b.classList.remove('is-busy');
        if (!res.ok) { if (msg) msg.textContent = res.j.description || res.j.message || 'Error'; return; }
        document.dispatchEvent(new CustomEvent('theme:cart:added', { bubbles: true }));
        var code = box.getAttribute('data-code');
        if (mode === 'both' && code) window.location.href = rootUrl + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(rootUrl + 'cart');
        else window.location.href = rootUrl + 'cart';
      })
      .catch(function () { b.classList.remove('is-busy'); window.location.href = rootUrl + 'cart'; });
  });

  /* ---------- Launch: locked until the door opens, then Add to cart by itself ---------- */
  function launchAt() {
    var el = document.querySelector('[data-mtl-cart]');
    var t = el ? Date.parse(el.getAttribute('data-launch') || '') : NaN;
    return t;
  }
  function setLocked(on) {
    root.classList.toggle('mtl-locked', on);
    document.querySelectorAll('[data-mtl-add]').forEach(function (b) {
      if (on) b.setAttribute('aria-disabled', 'true'); else b.removeAttribute('aria-disabled');
    });
    document.querySelectorAll('[data-mtl-prelaunch]').forEach(function (x) { x.hidden = !on; });
  }
  (function () {
    var t = launchAt();
    if (isNaN(t)) { setLocked(false); return; }
    var cells = document.querySelectorAll('[data-mtl-count] b, [data-mtl-count-mini] b');
    function tick() {
      var d = t - Date.now();
      if (d <= 0) { setLocked(false); return; }
      setLocked(true);
      var v = [Math.floor(d / 864e5), Math.floor(d / 36e5) % 24, Math.floor(d / 6e4) % 60, Math.floor(d / 1e3) % 60];
      document.querySelectorAll('[data-mtl-count], [data-mtl-count-mini]').forEach(function (box) {
        box.querySelectorAll('b').forEach(function (c, i) { c.textContent = (v[i] < 10 ? '0' : '') + v[i]; });
      });
      setTimeout(tick, 1000);
    }
    tick();
  })();

  /* Duo card: show both watches lit together */
  function duoView(on) {
    if (root.classList.contains('mtl-duo-view') === on) return;
    root.classList.toggle('mtl-duo-view', on);
    document.dispatchEvent(new CustomEvent('mictlan:duo', { detail: { on: on } }));
  }
  document.addEventListener('pointerover', function (e) { if (e.target.closest && e.target.closest('[data-mtl-duo-view]')) duoView(true); });
  document.addEventListener('pointerout', function (e) {
    var c = e.target.closest && e.target.closest('[data-mtl-duo-view]');
    if (c && !(e.relatedTarget && c.contains(e.relatedTarget)) && e.pointerType === 'mouse') duoView(false);
  });
  document.addEventListener('focusin', function (e) { duoView(!!(e.target.closest && e.target.closest('[data-mtl-duo-view]'))); });
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-mtl-pick-btn]')) duoView(false);
    else if (e.target.closest && e.target.closest('[data-mtl-duo-view]')) duoView(true);
  });

  /* Product photo strip: arrows instead of a scrollbar */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-mtl-gal]');
    if (!b) return;
    var g = b.parentNode.querySelector('.mtl-gal');
    if (g) g.scrollBy({ left: (+b.getAttribute('data-mtl-gal')) * g.clientWidth * 0.75, behavior: RM ? 'auto' : 'smooth' });
  });

  /* Lightbox: photos open full screen with previous / next */
  var lb = null, lbItems = [], lbIndex = 0, lbReturn = null;
  function lbBuild() {
    lb = document.createElement('div');
    lb.className = 'mtl-lb';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.hidden = true;
    lb.innerHTML = '<div class="mtl-lb__stage"><img alt=""></div>' +
      '<button type="button" class="mtl-lb__btn mtl-lb__prev" aria-label="Anterior"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg></button>' +
      '<button type="button" class="mtl-lb__btn mtl-lb__next" aria-label="Siguiente"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg></button>' +
      '<button type="button" class="mtl-lb__close" aria-label="Cerrar"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg></button>' +
      '<p class="mtl-lb__count"></p>';
    document.body.appendChild(lb);
    lb.querySelector('.mtl-lb__prev').addEventListener('click', function () { lbGo(lbIndex - 1); });
    lb.querySelector('.mtl-lb__next').addEventListener('click', function () { lbGo(lbIndex + 1); });
    lb.querySelector('.mtl-lb__close').addEventListener('click', lbClose);
    lb.addEventListener('click', function (e) { if (e.target === lb || e.target.classList.contains('mtl-lb__stage')) lbClose(); });
    var x0 = null;
    lb.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    lb.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) lbGo(lbIndex + (dx < 0 ? 1 : -1));
    });
  }
  function lbGo(i) {
    if (!lbItems.length) return;
    lbIndex = (i + lbItems.length) % lbItems.length;
    var img = lb.querySelector('img'), it = lbItems[lbIndex];
    img.classList.remove('is-in');
    img.onload = function () { img.classList.add('is-in'); };
    img.src = it.getAttribute('href') || it.getAttribute('data-href');
    img.alt = it.getAttribute('aria-label') || '';
    lb.querySelector('.mtl-lb__count').textContent = (lbIndex + 1) + ' / ' + lbItems.length;
    var many = lbItems.length > 1;
    lb.querySelector('.mtl-lb__prev').hidden = !many;
    lb.querySelector('.mtl-lb__next').hidden = !many;
  }
  function lbOpen(item) {
    if (!lb) lbBuild();
    var group = item.closest('[data-mtl-lb-group]');
    lbItems = Array.prototype.slice.call((group || document).querySelectorAll('[data-mtl-lb]'));
    lbReturn = item;
    lb.style.setProperty('--g', getComputedStyle(item).getPropertyValue('--g') || getComputedStyle(root).getPropertyValue('--mtl-glow'));
    lb.hidden = false;
    document.documentElement.classList.add('mtl-lb-open');
    lbGo(lbItems.indexOf(item));
    lb.querySelector('.mtl-lb__close').focus();
  }
  function lbClose() {
    if (!lb || lb.hidden) return;
    lb.hidden = true;
    document.documentElement.classList.remove('mtl-lb-open');
    if (lbReturn) lbReturn.focus();
  }
  document.addEventListener('click', function (e) {
    var it = e.target.closest && e.target.closest('[data-mtl-lb]');
    if (!it) return;
    e.preventDefault();
    lbOpen(it);
  });
  document.addEventListener('keydown', function (e) {
    if (lb && !lb.hidden) {
      if (e.key === 'Escape') lbClose();
      else if (e.key === 'ArrowRight') lbGo(lbIndex + 1);
      else if (e.key === 'ArrowLeft') lbGo(lbIndex - 1);
      return;
    }
    var it = e.target.closest && e.target.closest('[data-mtl-lb]');
    if (it && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); lbOpen(it); }
  });

  /* Reveal on scroll */
  var rev = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); rev.unobserve(e.target); } });
  }, { threshold: 0.15 });
  function scan(root) {
    (root || document).querySelectorAll('[data-mtl-reveal]:not(.is-in)').forEach(function (el) {
      if (DESIGN || RM) el.classList.add('is-in'); else rev.observe(el);
    });
  }
  scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });

  /* Duo panels: tap to open on touch */
  document.addEventListener('click', function (e) {
    var p = e.target.closest && e.target.closest('.mtl-duo__p');
    if (!p || !window.matchMedia('(hover: none)').matches) return;
    if (!p.classList.contains('is-open') && !e.target.closest('.mtl-btn')) {
      e.preventDefault();
      p.parentNode.querySelectorAll('.mtl-duo__p').forEach(function (o) { o.classList.toggle('is-open', o === p); });
    }
  });

  /* "#mtl-buy" links scroll to the theme's buy box */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href="#mtl-buy"]');
    if (!a) return;
    var t = document.querySelector('[data-mtl-buy], .product-single, [data-section-type="product-template"]');
    if (t) { e.preventDefault(); t.scrollIntoView({ behavior: RM ? 'auto' : 'smooth', block: 'start' }); }
  });

  /* Theme editor: jump to the selected chapter */
  document.addEventListener('shopify:block:select', function (e) {
    var step = e.target.closest && e.target.closest('[data-step]');
    var ch = step && step.closest('mtl-chapters');
    if (ch) ch.go(+step.dataset.step);
    var p = e.target.classList && e.target.classList.contains('mtl-duo__p') ? e.target : null;
    if (p) p.parentNode.querySelectorAll('.mtl-duo__p').forEach(function (o) { o.classList.toggle('is-open', o === p); });
  });
})();
